import React, { Component } from 'react'
import { Prompt } from 'react-router-dom/cjs/react-router-dom.min'
import Alert from '../Alert/Alert'

export default class RouterPrompt extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showAlert: false,
            lastLocation: null,
            isConfirmed: false,
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.showDefaultPrompt)
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.showDefaultPrompt)
    }

    showDefaultPrompt = (e) => {
        if (this.props.when) {
            e.returnValue = "Perubahan tidak akan disimpan?"
        }
    }

    showAlert = (show = true, lastLocation = null) => {
        return this.setState({
            showAlert: show,
            lastLocation: lastLocation
        })
    }

    handleBlockedNavigation = (nextLocation) => {
        const currentLocation = document.location
        const currentPath = currentLocation.pathname + currentLocation.search

        if (currentPath === nextLocation.pathname + nextLocation.search) {
            return true
        }

        if (!this.state.isConfirmed) {
            this.showAlert(true, nextLocation)
            return false
        }

        this.setState({
            isConfirmed: false
        })
        return true
    }

    handleRedirect = () => {
        if (!this.state.lastLocation) {
            return
        }

        const lastLocation = this.state.lastLocation
    
        this.showAlert(false, null)
        this.setState({
            isConfirmed: true
        }, () => this.props.history.push(lastLocation.pathname + lastLocation.search))
    }
    
    render() {
        return (
            <>
                <Prompt 
                    when={this.props.when}
                    message={this.handleBlockedNavigation}
                />
                <Alert 
                    show={this.state.showAlert} 
                    title="Tinggalkan Halaman"
                    desc="Perubahan yang Anda buat mungkin tidak disimpan"
                    submit={() => this.showAlert(false)}
                    close={this.handleRedirect}
                    buttonOKText="Tetap Dihalaman"
                    buttonCancelText="Tinggalkan Halaman"
                    maxContentButtons
                    button 
                />
            </>
        )
    }
}
